import React, {Component} from "react";
import {
    Button,
    FormField,
    FormSection,
    Hint,
    Input,
    InputLabel,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

export class ConfirmSignUpComponent extends Component {
    render() {
        return (
            <div>
            <Header/>
            <FormSection theme={this.props.theme}>
            <SectionHeader theme={this.props.theme}>
                {I18n.get("Custom Confirm Sign Up")}
            </SectionHeader>
            <SectionBody theme={this.props.theme}>
                <FormField theme={this.props.theme}>
                    <InputLabel theme={this.props.theme}>{I18n.get("Username")} *</InputLabel>
                    <Input
                        placeholder={I18n.get("Username")}
                        theme={this.props.theme}
                        key="username"
                        name="username"
                        onChange={this.props.myConfirmSignUp.handleInputChange}
                        disabled={this.props.username}
                        value={this.props.username ? this.props.username : ""}
                    />
                </FormField>

                <FormField theme={this.props.theme}>
                    <InputLabel theme={this.props.theme}>{I18n.get("Code")} *</InputLabel>
                    <Hint theme={this.props.theme}>{I18n.get("Hint authorization code in Confirm SignUp screen")}</Hint>
                    <InputLabel theme={this.props.theme}>{this.props.code_err_msg}</InputLabel>
                    <Input
                        autoFocus
                        placeholder={I18n.get("Enter your code")}
                        theme={this.props.theme}
                        key="code"
                        name="code"
                        type="number"
                        value={this.props.code}
                        autoComplete="off"
                        onChange={this.props.myConfirmSignUp.handleInputChangeCustom}
                    />
                    <Hint theme={this.props.theme}>
                        {I18n.get("Lost your code? ")}
                        <Link theme={this.props.theme} style={this.props.resendCodeStyle}  disabled={this.props.isResendCodeDisable} onClick={this.props.myConfirmSignUp.resend}>
                            {I18n.get("Resend Code")}
                        </Link>
                    </Hint>
                </FormField>
            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    <Button theme={this.props.theme} disabled={this.props.isConfirmSignUpDisable} onClick={this.props.confirm}>
                        {I18n.get("Confirm")}
                    </Button>
                </SectionFooterPrimaryContent>
            </SectionFooter>
        </FormSection>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

ConfirmSignUpComponent.propTypes = {
    theme: PropTypes.any,
    myConfirmSignUp: PropTypes.any,
    username: PropTypes.any,
    confirm: PropTypes.func,
    code: PropTypes.string,
    handleInputChangeCustom: PropTypes.func,
    isResendCodeDisable: PropTypes.bool,
    isConfirmSignUpDisable: PropTypes.bool,
    mode: PropTypes.string,
    resendCodeStyle: PropTypes.string,
    code_err_msg: PropTypes.any,
    changeStateFunc: PropTypes.func
};